import { TipoEventoNFeEnum } from '@shared/enums/dfe/tipo-evento-nfe.enum';

export class ManifestarNotaFiscalEntradaDialogResult {
  idTipoEvento: TipoEventoNFeEnum;
  justificativa: string | null = null;
}
